var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Bar',{attrs:{"chart-id":"1","chart-data":_vm.chartData,"chart-options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }